import { PostRepository } from '../repositories';
import { logger } from '@/src/core/utils';

export class LikePostUseCase {
  constructor(private postRepository: PostRepository) {}

  async execute(postId: string, userId: string): Promise<void> {
    logger.debug('LikePost', 'Liking post', { postId, userId });

    await this.postRepository.likePost(postId, userId);

    logger.debug('LikePost', 'Successfully liked post');
  }
}
